import Service from './Service';

class StripeService {
  private static URL_BASE = process.env.REACT_APP_URL_API;
  private static URL_CAPTURE_PAYMENT = (id: number) => `${this.URL_BASE}/rental/admin/${id}/capture`;
  
  static async capturePayment(id: number, applyReferralDiscount = false): Promise<{ success: boolean }> {
    return Service.post(this.URL_CAPTURE_PAYMENT(id), { applyReferralDiscount });
  }
}

export default StripeService;